import React, { Component } from 'react';

import './Obstacle.css';


class Obstacle extends Component {

    render() {
        
        return (
            <div className="obstacle"/>
        );
    }
}

export default Obstacle;


// WEBPACK FOOTER //
// ./src/components/Obstacle/Obstacle.js